<template>
  <Menu></Menu>
  <div id="box">
    <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-currency-dollar">&nbsp; Manage Prices</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadPrices()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->                    
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        <div class="col p-0">
        </div>
        
        <div class="col p-0">
          <button v-if="$store.getters.access(['cost_edit', 'price_edit'])"  class="btn btn-success w-100" @click="savePrices()" :disabled="loading">
            <span class="bi-floppy">&nbsp; Save</span>
          </button>
        </div>


      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="w-15">Brand</th>
          <th class="w-15">Size</th>
          <th class="w-15">Pattern</th>
          <th class="">Barcode</th>
          <th v-if="$store.getters.access('cost')" class="w-10 text-center">Cost</th>
          <th v-if="$store.getters.access('price')" class="w-10 text-center">Price</th>
          <th v-if="tax > 0 && $store.getters.access('price')" class="w-10 text-center">Price after <br> {{tax}}% Tax</th>
          <th v-if="$store.getters.access('price')" class="w-10 text-center">Premium <br> WS Price</th>
          <th v-if="ws_rate > 0 && $store.getters.access('price')" class="w-10 text-center">Regular WS Price {{ws_rate}}%</th>
          <th class="w-5 text-center">Restore</th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="tire in tires_filtered" :key="tire._id">
          <td class="w-15">{{ tire.brand }}</td>
          <td class="w-15">{{ tire.size }}</td>
          <td class="w-15">{{ tire.pattern }}</td>
          <td class="">{{ tire.barcode }}</td>
          <td v-if="$store.getters.access('cost')" class="w-10 text-center">
            <input class="inside"  type='number' v-model.number=tire.cost :class="tire.cost != tire.costOriginal ? 'redBox' : ''">
          </td>
          <td v-if="$store.getters.access('price')" class="w-10 text-center">
            <input class="inside"  type='number' v-model.number=tire.price :class="tire.price != tire.priceOriginal ? 'redBox' : ''">
          </td>
          <td v-if="tax > 0 && $store.getters.access('price')" class="w-10 text-center">
            <p>{{ ((tire.price || 0) * (100 + tax) / 100).toFixed(2) }}</p>
          </td>
          <td v-if="$store.getters.access('price')" class="w-10 text-center">
            <input class="inside"  type='number' v-model.number=tire.ws_price :class="tire.ws_price != tire.ws_priceOriginal ? 'redBox' : ''">
          </td>
          <td v-if="ws_rate > 0 && $store.getters.access('price')" class="w-10 text-center">
            <p>{{ ((tire.ws_price || 0) * (100 + ws_rate) / 100).toFixed(2) }}</p>
          </td>
          <td class="w-5 text-center unselect">
            <a class="btn btn-sm btn-primary bi-arrow-clockwise w-100" @click="restore(tire)"></a>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  // const $ = require('jquery');
  export default {
    name: 'PricesPage',
    data(){
      return {
        loading: false,
        tires: [],
        filter: '',
        tax: 0,
        ws_rate: 0,
      }
    },
    created() {
      this.loadPrices();
      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    mounted(){
    },
    //**********************************************************
    computed:{
      tires_filtered(){
        let filter = this.filter.toLowerCase();
        return this.tires.filter((x)=>{
          if(x.barcode && x.barcode.toLowerCase().includes(filter)) return true;
          if(x.brand && x.brand.toLowerCase().includes(filter)) return true;
          if(x.size && x.size.toLowerCase().includes(filter)) return true;
          if(x.pattern && x.pattern.toLowerCase().includes(filter)) return true;
          return false;
        });
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadPrices(){
        this.loading = true;
        this.tires = [];
        var ack = await this.$service.getPrices();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.tires = ack.data.tires;
          this.tax = ack.data.tax;
          this.ws_rate = ack.data.ws_rate;
        }
        this.loading = false;
      },
      //**********************************************************
      async savePrices(){
        this.loading = true;
        await this._savePrices();
        this.loading = false;
        this.loadPrices();
      },
      //**********************************************************
      async onBarcodeScan(code){
        this.filter = code;
      },
      //**********************************************************
      async _savePrices(){
        var payload = this.tires.map((x)=>{
          return { '_id': x._id, 'cost': x.cost, 'price': x.price, 'ws_price': x.ws_price }
        })
        var ack = await this.$service.savePrices({'items': payload});
        if(ack.state != 'OK') return this.$toast(ack.state);
        this.$toast('Prices Saved Successfuly', 'success');
      },
      //**********************************************************
      restore(tire){
        tire.cost = tire.costOriginal;
        tire.price = tire.priceOriginal;
        tire.ws_price = tire.ws_priceOriginal;
      }
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
.inside{
    width: 100%;
    border: 1px solid black;
    text-align: center;
    background: none;
    -moz-appearance: textfield;
}
.inside::-webkit-outer-spin-button,
.inside::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.redBox{
  background-color: #cbf5dd !important;
}
</style>
  